import * as React from "react";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";

import { AttrView } from "./attrViews";
import { ZAttrMeta } from "./ZAttrMeta";
import { ZSafeDataMap } from "./ZAttrValue";

export const makeAttrColumn = <Record extends { data: ZSafeDataMap }>(
  attr: ZAttrMeta,
  specName: string,
): RtColumn<Record> => ({
  key: `${specName}/${attr.name}`,
  title: attr.title,
  render: ({ data }) => {
    const schemeData = data[specName];
    const attrValue = schemeData?.[attr.name];
    if (!attrValue) return null;
    return <AttrView value={attrValue} meta={attr} />;
  },
  width: attr.view?.width ?? undefined,
  minWidth: attr.view?.minWidth ?? undefined,
});
